export const EVENT_TYPES = {
  CALL_RECORDING: '#microsoft.graph.callRecordingEventMessageDetail',
  CALL_TRANSCRIPT: '#microsoft.graph.callTranscriptEventMessageDetail',
  CALL_ENDED: '#microsoft.graph.callEndedEventMessageDetail',
  CALL_STARTED: '#microsoft.graph.callStartedEventMessageDetail',
  MEMBERS_ADDED: '#microsoft.graph.membersAddedEventMessageDetail',
  MEMBERS_DELETED: '#microsoft.graph.membersDeletedEventMessageDetail',
  CHAT_RENAMED: '#microsoft.graph.chatRenamedEventMessageDetail',
};

export async function getMe(graph) {
  return graph.request('/me');
}

export async function* listChats(graph, { since = null, until = null } = {}) {
  const params = new URLSearchParams({ $expand: 'members', $top: '50' });
  const filters = [];
  if (since) filters.push(`lastUpdatedDateTime ge ${since}`);
  if (until) filters.push(`lastUpdatedDateTime le ${until}`);
  if (filters.length) params.set('$filter', filters.join(' and '));
  const query = `/me/chats?${params.toString()}`;
  for await (const chat of graph.paginate(query)) {
    yield chat;
  }
}

export function chatDisplayName(chat, meId = null) {
  if (chat.topic) return chat.topic;
  const others = (chat.members || []).filter((m) => !meId || m.userId !== meId);
  if (chat.chatType === 'oneOnOne') {
    const other = others[0] || chat.members?.[0];
    if (other?.displayName) return other.displayName;
  }
  if (chat.chatType === 'meeting') {
    return `Meeting ${new Date(chat.createdDateTime || Date.now()).toISOString().slice(0, 16)}`;
  }
  const names = others.map((m) => m.displayName).filter(Boolean);
  return names.length ? names.join(', ') : `Chat ${chat.id.slice(-8)}`;
}

export function conversationKind(chat) {
  switch (chat.chatType) {
    case 'oneOnOne':
    case 'group':
      return 'chats';
    case 'meeting':
      return 'meeting-chats';
    default:
      return 'chats';
  }
}

export async function* listChatMessages(graph, chatId, { since = null } = {}) {
  // Graph only supports descending order on this endpoint (newest first).
  // For incremental runs we bail out as soon as we cross the "since" cutoff
  // — no server-side $filter needed, no wasted pages.
  const path = `/me/chats/${encodeURIComponent(chatId)}/messages?$top=50`;
  for await (const message of graph.paginate(path)) {
    if (since && message.createdDateTime && message.createdDateTime <= since) return;
    yield message;
  }
}

export async function* listHostedContents(graph, chatId, messageId) {
  const path = `/chats/${encodeURIComponent(chatId)}/messages/${encodeURIComponent(messageId)}/hostedContents`;
  for await (const hc of graph.paginate(path)) {
    yield hc;
  }
}

export async function* listJoinedTeams(graph) {
  for await (const team of graph.paginate('/me/joinedTeams')) yield team;
}

export async function* listChannels(graph, teamId) {
  for await (const channel of graph.paginate(`/teams/${encodeURIComponent(teamId)}/channels`)) {
    yield channel;
  }
}

export async function* listChannelMessages(graph, teamId, channelId) {
  const path = `/teams/${encodeURIComponent(teamId)}/channels/${encodeURIComponent(channelId)}/messages?$top=50`;
  for await (const message of graph.paginate(path)) {
    yield message;
    // channel messages have replies as a sub-collection
    if (message.replies?.length) {
      for (const reply of message.replies) yield reply;
    }
  }
}

